import axios from 'axios';

const _localStorage = window.localStorage || {
  setItem: () => true,
  getItem: () => null,
};

const baseUrl =
  process.env.VUE_APP_API || 'http://api.local.dpty.io/personal/v1';
const http = axios.create({
  baseURL: baseUrl,
  timeout: 5000,
  crossdomain: true,
  transformRequest: [
    function(data, headers) {
      headers.common['Authorization'] = `Bearer ${_localStorage.getItem(
        'DEPUTY_SO:jwt'
      )}`;
      return JSON.stringify(data);
    },
  ],
});

export default http;
export { http, baseUrl };
